import { companiesCompanyIdCustomDomains } from "@dashboardApi/apis/companiesCompanyIdCustomDomains";
import { companiesCompanyIdCustomDomainsLimits } from "@dashboardApi/apis/companiesCompanyIdCustomDomainsLimits";

import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdCustomDomainsDomainTypeDomainId =
  "/companies/:company_id/custom_domains/:domain_type/:domain_id";

export const deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainIdCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdCustomDomains,
  companiesCompanyIdCustomDomainsLimits,
  companiesCompanyIdCustomDomainsDomainTypeDomainId,
];

export const getCompaniesCompanyIdCustomDomainsDomainTypeDomainIdQueryKey = (
  appGroupId: string,
  companyId: string,
  domainType: string,
  domainId: string
) => {
  return [
    { cacheKey: companiesCompanyIdCustomDomainsDomainTypeDomainId, appGroupId },
    companyId,
    domainType,
    domainId,
  ];
};
